import API from '@/api/Api'
import {
  GetChatSessions,
  GetChatMessages,
  GetChatGreeting,
  GetChatSuggestions,
  DeleteChatSession
} from '@/api/query/AiAssistant.graphql'

export default {

  async getChatSessions (accountId, userId, limit) {
    const Data = { accountId: accountId, userId: userId, limit: limit }
    return await API.GQLRequest(GetChatSessions, Data)
  },

  async getChatMessages (accountId, sessionId) {
    const Data = { accountId: accountId, sessionId: sessionId }
    return await API.GQLRequest(GetChatMessages, Data)
  },

  async getChatGreeting (accountId, userId) {
    const Data = { accountId: accountId, userId: userId }
    return await API.GQLRequest(GetChatGreeting, Data)
  },

  async getChatSuggestions (accountId, page) {
    const Data = { accountId: accountId, page: page }
    return await API.GQLRequest(GetChatSuggestions, Data)
  },

  async deleteChatSession (userId, accountId, sessionId) {
    const Data = { userId: userId, accountId: accountId, sessionId: sessionId }
    return await API.GQLRequest(DeleteChatSession, Data)
  }

}
